import { Navigate, Route, Routes } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login/login";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Profilesettings from "../settings/generalSettings/profile-settings";
import Securitysettings from "../settings/generalSettings/security-settings";
import Notificationssettings from "../settings/generalSettings/notifications-settings";
import ConnectedApps from "../settings/generalSettings/connected-apps";
import Bussinesssettings from "../settings/websiteSettings/bussiness-settings";
import Seosettings from "../settings/websiteSettings/seo-settings";
import CompanySettings from "../settings/websiteSettings/companySettings";
import Localizationsettings from "../settings/websiteSettings/localization-settings";
import Prefixes from "../settings/websiteSettings/prefixes";
import Preference from "../settings/websiteSettings/preferences";
import Authenticationsettings from "../settings/websiteSettings/authentication-settings";
import Languagesettings from "../settings/websiteSettings/language";
import InvoiceSettings from "../settings/appSettings/invoiceSettings";
import CustomFields from "../settings/appSettings/customFields";
import EmailSettings from "../settings/systemSettings/emailSettings";
import Emailtemplates from "../settings/systemSettings/email-templates";
import SmsSettings from "../settings/systemSettings/smsSettings";
import OtpSettings from "../settings/systemSettings/otp-settings";
import GdprCookies from "../settings/systemSettings/gdprCookies";
import PaymentGateways from "../settings/financialSettings/paymentGateways";
import TaxRates from "../settings/financialSettings/taxRates";
import Storage from "../settings/otherSettings/storage";
import BanIpAddress from "../settings/otherSettings/banIpaddress";
import Appearance from "../settings/websiteSettings/appearance";
import LayoutDemo from "../mainMenu/layout-dashoard";
import Aisettings from "../settings/websiteSettings/ai-settings";
import Salarysettings from "../settings/appSettings/salary-settings";
import Approvalsettings from "../settings/appSettings/approval-settings";
import LeaveType from "../settings/appSettings/leave-type";
import SmsTemplate from "../settings/systemSettings/sms-template";
import Maintenancemode from "../settings/systemSettings/maintenance-mode";
import Currencies from "../settings/financialSettings/currencies";
import Customcss from "../settings/otherSettings/custom-css";
import Customjs from "../settings/otherSettings/custom-js";
import Cronjob from "../settings/otherSettings/cronjob";
import Cronjobschedule from "../settings/otherSettings/cronjobSchedule";
import Backup from "../settings/otherSettings/backup";
import Clearcache from "../settings/otherSettings/clearCache";
import Languageweb from "../settings/websiteSettings/language-web";
import Addlanguage from "../settings/websiteSettings/add-language";
import AdminDashboard from "../mainMenu/adminDashboard";
import AttendanceRouter from "./AttendanceRouter";
import PayHeader from "../payHeader/PayHeader";
import DocumentHeader from "../documentHeader/DocumentHeader";
import Designations from "../designation/designations";
import Employees from "../employees/employees";
import Profile from "../profile/profile";
import Payroll from "../payroll/payroll";
import Vendor from "../vendor/Vendor";
import Holidays from "../holidays/holidays";
import Leave from "../leave/Leave";
import Inventory from "../inventory/Inventory";
import MonthlySalary from "../payroll/monthlySalary";
import EmployeeSalary from "../payroll/employeeSalary";
import LeaveCalendar from "../leave/LeaveCalendar";
import AllNotifications from "../notifications/AllNotifications";
import Resumes from "../resumes/Resumes";
import JobOpenings from "../jobOpenings/JobOpenings";
import Interviews from "../interviews/Interviews";
import Banners from "../Banners/Banners";
import PolicyDocument from "../policyDocument/PolicyDocument";
import InductionChecklist from "../inductionChecklist/InductionChecklist";
import AccessRevokeChecklist from "../accessRevoke/AccessRevokeChecklist";
import AppStoreSettings from "../appStore/app-store-settings";
const routes = all_routes;

export const privateRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.dashboard,
    element: <AdminDashboard/>,
    route: Route,
    allowedRoles: [1,2],
  },
  {
    path: routes.attendance,
    element: <AttendanceRouter />,
    route: Route,
    allowedRoles: [1, 2],
  },  
  {
    path: "/attendance-view",
    element: <AttendanceRouter />,
    route: Route,
    allowedRoles: [1, 2],
  },  
  {
    path: routes.employees,
    element: <Employees />,
    route: Route,
    allowedRoles: [1],
  },{
    path: routes.holidays,
    element: <Holidays />,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: routes.payroll,
    element: <Payroll />,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: "/monthlySalary",
    element: <MonthlySalary/>,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: "/employeeSalary",
    element: <EmployeeSalary/>,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: routes.leave,
    element: <Leave />,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: routes.leaveCalendar,
    element: <LeaveCalendar />,
    route: Route,
    allowedRoles: [1,2],
  },{
    path: routes.documentHeader,
    element: <DocumentHeader />,
    route: Route,
    allowedRoles: [1],
  },{
    path: routes.payHeader,
    element: <PayHeader />,
    route: Route,
    allowedRoles: [1],
  },{
    path: routes.vendors,
    element: <Vendor />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.policyDocument,
    element: <PolicyDocument />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.inductionChecklist,
    element: <InductionChecklist />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.accessRevokeChecklist,
    element: <AccessRevokeChecklist />,
    route: Route,
    allowedRoles: [1],
  },
    {
    path: routes.appStoreSettings,
    element: <AppStoreSettings />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.inventory,
    element: <Inventory />,
    route: Route,
    allowedRoles: [1],
  },{
    path: routes.designation,
    element: <Designations />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.holidays,
    element: <Holidays/>,
    route: Routes,
    allowedRoles: [1],
  },
  {
    path: routes.profile,
    element: <Profile />,
    route: Route,
    allowedRoles: [1,2],
  },
  {
    path: routes.AllNotifications,
    element: <AllNotifications />,
    route: Route,
    allowedRoles: [1,2],
  },
  {
    path: routes.resumes,
    element: <Resumes />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.jobOpenings,
    element: <JobOpenings />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.interviews,
    element: <Interviews />,
    route: Route,
    allowedRoles: [1,2],
  },
  {
    path: routes.banners,
    element: <Banners />,
    route: Route,
    allowedRoles: [1],
  },
  {
    path: routes.customFields,
    element: <CustomFields />,
    route: Route,
  },
  {
    path: routes.banIpAddress,
    element: <BanIpAddress />,
    route: Route,
  },
  {
    path: routes.Horizontal,
    element: <LayoutDemo />,
  },
  {
    path: routes.Detached,
    element: <LayoutDemo />,
  },
  {
    path: routes.Modern,
    element: <LayoutDemo />,
  },
  {
    path: routes.TwoColumn,
    element: <LayoutDemo />,
  },
  {
    path: routes.Hovered,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalSingle,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalOverlay,
    element: <LayoutDemo />,
  },
  {
    path: routes.HorizontalBox,
    element: <LayoutDemo />,
  },
  {
    path: routes.MenuAside,
    element: <LayoutDemo />,
  },
  {
    path: routes.Transparent,
    element: <LayoutDemo />,
  },
  {
    path: routes.WithoutHeader,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutRtl,
    element: <LayoutDemo />,
  },
  {
    path: routes.layoutDark,
    element: <LayoutDemo />,
  },

  //Settings

  {
    path: routes.profilesettings,
    element: <Profilesettings />,
  },
  {
    path: routes.securitysettings,
    element: <Securitysettings />,
  },
  {
    path: routes.notificationssettings,
    element: <Notificationssettings />,
  },
  {
    path: routes.connectedApps,
    element: <ConnectedApps />,
  },
  {
    path: routes.bussinessSettings,
    element: <Bussinesssettings />,
  },
  {
    path: routes.seoSettings,
    element: <Seosettings />,
  },
  {
    path: routes.companySettings,
    element: <CompanySettings />,
  },
  {
    path: routes.localizationSettings,
    element: <Localizationsettings />,
  },
  {
    path: routes.prefixes,
    element: <Prefixes />,
  },
  {
    path: routes.preference,
    element: <Preference />,
  },
  {
    path: routes.authenticationSettings,
    element: <Authenticationsettings />,
  },
  {
    path: routes.aiSettings,
    element: <Aisettings />,
  },
  {
    path: routes.salarySettings,
    element: <Salarysettings />,
  },
  {
    path: routes.approvalSettings,
    element: <Approvalsettings />,
  },
  {
    path: routes.appearance,
    element: <Appearance />,
  },
  {
    path: routes.language,
    element: <Languagesettings />,
  },
  {
    path: routes.languageWeb,
    element: <Languageweb />,
  },
  {
    path: routes.addLanguage,
    element: <Addlanguage />,
  },
 
 
  {
    path: routes.invoiceSettings,
    element: <InvoiceSettings />,
  },
  {
    path: routes.customFields,
    element: <CustomFields />,
  },
  {
    path: routes.leaveType,
    element: <LeaveType />,
  },
  {
    path: routes.emailSettings,
    element: <EmailSettings />,
  },
  {
    path: routes.emailTemplates,
    element: <Emailtemplates />,
  },
  {
    path: routes.smsSettings,
    element: <SmsSettings />,
  },
  {
    path: routes.smsTemplate,
    element: <SmsTemplate />,
  },
  {
    path: routes.otpSettings,
    element: <OtpSettings />,
  },
  {
    path: routes.gdprCookies,
    element: <GdprCookies />,
  },
  {
    path: routes.maintenanceMode,
    element: <Maintenancemode />,
  },

  {
    path: routes.paymentGateways,
    element: <PaymentGateways />,
  },
  {
    path: routes.taxRates,
    element: <TaxRates />,
  },
  {
    path: routes.currencies,
    element: <Currencies />,
  },
  {
    path: routes.backup,
    element: <Backup />,
  },
  {
    path: routes.clearcache,
    element: <Clearcache />,
  },
  {
    path: routes.customCss,
    element: <Customcss />,
  },
  {
    path: routes.customJs,
    element: <Customjs />,
  },
  {
    path: routes.cronjob,
    element: <Cronjob />,
  },
  {
    path: routes.Cronjobschedule,
    element: <Cronjobschedule />,
  },
  {
    path: routes.storage,
    element: <Storage />,
  },
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
    allowedRoles: [1,2],
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    allowedRoles: [1,2],
  },
];
